import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HiBriefcase, HiAcademicCap } from 'react-icons/hi';
import { useLanguage } from '../i18n/LanguageContext';
import './Experience.css';

const Experience = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState(0);

  const jobs = t('experience.jobs');
  const education = t('experience.education');

  return (
    <section className="experience section" id="experience">
      <div className="container">
        <motion.div
          className="experience__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">{t('experience.label')}</span>
          <h2 className="section-title">
            {t('experience.titleStart')}<span className="gradient-text">{t('experience.titleHighlight')}</span>
          </h2>
          <p className="section-subtitle">{t('experience.subtitle')}</p>
        </motion.div>

        <motion.div
          className="experience__work"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="experience__tabs">
            {jobs.map((exp, i) => (
              <button
                key={i}
                className={`experience__tab ${activeTab === i ? 'experience__tab--active' : ''}`}
                onClick={() => setActiveTab(i)}
              >
                {exp.company}
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              className="experience__detail"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="experience__role">
                {jobs[activeTab].role}
                <span className="experience__company">
                  {' '}@ {jobs[activeTab].company}
                </span>
              </h3>
              <p className="experience__period">
                <HiBriefcase />
                {jobs[activeTab].period}
                {jobs[activeTab].location && ` · ${jobs[activeTab].location}`}
              </p>
              <p className="experience__description">
                {jobs[activeTab].description}
              </p>
              <div className="experience__tags">
                {jobs[activeTab].tags.map((tag, i) => (
                  <span key={i} className="experience__tag">{tag}</span>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </motion.div>

        <motion.div
          className="experience__education"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h3 className="experience__section-title">
            <HiAcademicCap /> {t('experience.educationTitle')}
          </h3>
          <div className="experience__edu-grid">
            {education.map((edu, i) => (
              <motion.div
                key={i}
                className="experience__edu-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 * i + 0.4 }}
                whileHover={{ y: -4 }}
              >
                <div className="experience__edu-status">
                  <span className={`experience__edu-badge ${edu.status === 'In corso' || edu.status === 'In progress' ? 'experience__edu-badge--active' : ''}`}>
                    {edu.status}
                  </span>
                </div>
                <h4 className="experience__edu-degree">{edu.degree}</h4>
                <p className="experience__edu-institution">{edu.institution}</p>
                <p className="experience__edu-desc">{edu.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
